<div class="bid-confirm-overlay" *ngIf="visible">
  <div class="bid-confirm-modal">
    <button class="bid-confirm-close" (click)="onClose()">&times;</button>
    <div class="bid-confirm-logo-row">
      <img [src]="marketLogoUrl" class="bid-confirm-logo" alt="Market Logo" />
      <!-- <span class="bid-confirm-market-name">{{ marketName }}</span> -->
    </div>
    <h2 class="bid-confirm-heading">Thank You!</h2>
    <div class="bid-confirm-badge">
      <img src="../assets/images/SuccessTick.png" class="img-fluid" style="height: 95px;" alt="Sucess Tick" />
      <br />
    </div>
    <p class="bid-confirm-message">"Your Bid Has Been Successfully Submitted.!"</p>
    <a class="bid-confirm-receipt-link" *ngIf="!receiptUnavailable" (click)="onOpenReceipt()">Open Bid Receipt</a>
    <p class="bid-confirm-message" *ngIf="receiptUnavailable">Bid receipt is currently unavailable.</p>
    <div class="bid-confirm-actions">
      <button class="bid-confirm-btn" (click)="onHome()">Home</button>
      <button class="bid-confirm-btn" (click)="onPrint()" [disabled]="receiptUnavailable">Print</button>
    </div>
  </div>
</div>

<div bsModal #printReceiptPopup="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-fullSize modal-xl modal-xxl">
    <div class="modal-content" style="margin-top: 3rem;">
      <div class="modal-header">
        <h5 class="modal-title">Preview Receipt</h5>
        <!-- <button type="button" class="bid-confirm-btn" (click)="onPrint()" [disabled]="receiptUnavailable">Print</button> -->
        <button type="button" class="close" (click)="printReceiptPopup.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body previewModal" style="max-height:76vh;">
        <div>
          <iframe id="printf" #printf name="printf" style="width:100%; height:73.5vh" [src]="receiptSafeUrl">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</div>
